var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-289 381 32 32",
    style: {
      enableBackground: "new -289 381 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#28AB5F;}\n\t.st1{fill:#BFECCB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-261.6,412.3h-22.8c-2.1,0-3.8-1.7-3.8-3.9v-15.8c0-0.4,0.3-0.8,0.8-0.8h29c0.4,0,0.8,0.3,0.8,0.8v15.8 C-257.7,410.5-259.5,412.3-261.6,412.3z M-286.7,393.3v15.1c0,1.3,1,2.4,2.3,2.4h22.9c1.3,0,2.3-1.1,2.3-2.4v-15.1H-286.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258.5,389.7c0-1.7-1.4-3.1-3.1-3.1h-12.1c-1.3,0-2.5-0.8-2.9-2.1l0,0c-0.4-1.2-1.6-2-2.9-2h-5 c-1.7,0-3.1,1.4-3.1,3.1v7h29v-2.9H-258.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-258.5,393.3h-29c-0.4,0-0.8-0.3-0.8-0.8v-7c0-2.1,1.7-3.9,3.8-3.9h5c1.6,0,3.1,1,3.6,2.6 c0.3,0.9,1.2,1.6,2.2,1.6h12.1c2.1,0,3.8,1.7,3.8,3.9v2.8C-257.7,393-258.1,393.3-258.5,393.3z M-286.7,391.8h27.5v-2.1 c0-1.3-1-2.4-2.3-2.4h-12.2c-1.6,0-3.1-1-3.6-2.6c-0.3-0.9-1.2-1.6-2.2-1.6h-5c-1.3,0-2.3,1.1-2.3,2.4L-286.7,391.8L-286.7,391.8z "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseProject);
export default __webpack_public_path__ + "static/media/close_project.6a651edce8ec803c3d04a56d946bf68f.svg";
export { ForwardRef as ReactComponent };